export default class CBBA1010RequestModel {}
